export const getWeeksOfCurrentMonth = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);

  const weeks: { week: number; start: string; end: string }[] = [];

  // Segunda-feira como início da semana
  const firstWeekDay = (firstDayOfMonth.getDay() + 6) % 7;
  const currentStart = new Date(year, month, 1 - firstWeekDay);

  let weekNumber = 1;

  while (currentStart <= lastDayOfMonth) {
    const currentEnd = new Date(currentStart);
    currentEnd.setDate(currentStart.getDate() + 6);

    const start =
      currentStart < firstDayOfMonth ? firstDayOfMonth : currentStart;
    const end = currentEnd > lastDayOfMonth ? lastDayOfMonth : currentEnd;

    weeks.push({
      week: weekNumber,
      start: `${String(start.getDate()).padStart(2, '0')}/${String(
        start.getMonth() + 1
      ).padStart(2, '0')}`,
      end: `${String(end.getDate()).padStart(2, '0')}/${String(
        end.getMonth() + 1
      ).padStart(2, '0')}`,
    });

    currentStart.setDate(currentStart.getDate() + 7);
    weekNumber++;
  }

  return weeks;
};

export const getCurrentWeekNumber = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const today = now.getDate();

  const firstDay = new Date(year, month, 1);
  const firstDayWeekday = firstDay.getDay();
  const offset = (firstDayWeekday + 6) % 7;

  const currentStart = new Date(year, month, 1 - offset);

  let weekNumber = 1;
  while (currentStart.getMonth() <= month) {
    const currentEnd = new Date(currentStart);
    currentEnd.setDate(currentStart.getDate() + 6);

    const startDay =
      currentStart.getMonth() === month ? currentStart.getDate() : 1;
    const endDay =
      currentEnd.getMonth() === month
        ? currentEnd.getDate()
        : new Date(year, month + 1, 0).getDate();

    if (today >= startDay && today <= endDay) {
      return weekNumber;
    }

    currentStart.setDate(currentStart.getDate() + 7);
    weekNumber++;
    if (currentStart > new Date(year, month + 1, 0)) break;
  }

  return 1;
};

export function getDayOfWeek(dataStr: string) {
  const data = new Date(`${dataStr}T00:00:00`);
  const dias = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];
  return dias[data.getDay()];
}
